var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('themeTraining'),_c('diagnosis',{attrs:{"isHide":_vm.isHide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }